import createApi from './createApi';

export { default as createApi } from './createApi';

const api = createApi();

export default api;
